import type { Temporal } from 'temporal-polyfill';
import type { ContractSummary } from '@/api/schemas';
import { deriveContractStatus } from '@/lib/contractStatus';

export type SortKey =
  | 'type'
  | 'status'
  | 'vin'
  | 'customer'
  | 'contract'
  | 'policy'
  | 'dealer';

export type SortDirection = 'asc' | 'desc';

const sortValues: Record<
  SortKey,
  (contract: ContractSummary, today: Temporal.PlainDate) => string
> = {
  type: (contract) => contract.coverageType ?? '',
  status: (contract, today) => deriveContractStatus(contract, today),
  vin: (contract) => contract.vin,
  customer: (contract) => contract.customerName ?? '',
  contract: (contract) => contract.policyNumber,
  policy: (contract) => contract.policyNumber,
  dealer: (contract) => contract.dealerAccount,
};

export function sortContracts(
  contracts: readonly ContractSummary[],
  key: SortKey,
  direction: SortDirection,
  today: Temporal.PlainDate,
): ContractSummary[] {
  const value = sortValues[key];
  const sorted = [...contracts].sort((left, right) =>
    value(left, today).localeCompare(value(right, today), undefined, {
      numeric: true,
      sensitivity: 'base',
    }),
  );

  return direction === 'asc' ? sorted : sorted.reverse();
}
